import values from 'core/data-model/constants/values'

export const isZero = (validated) => {
  return validated.value === 0
}

export const hasError = (errors) => {
  return errors.filter(({ type }) => type !== values.ADDITIONAL_INFORMATION).length > 0
}

export const enableBasicSumAssured = (haveBasicPremiumState, basicPremium$) => {
  return haveBasicPremiumState ? basicPremium$.isOk || isZero(basicPremium$) : true
}

export const enableBasicPremium = (haveBasicPremiumState, sumAssured$) => {
  return haveBasicPremiumState ? true : sumAssured$.isOk || isZero(sumAssured$)
}

export const enableCoveragePeriod = (haveBasicPremiumState, coveragePeriod$) => {
  return haveBasicPremiumState ? coveragePeriod$.isOk || isZero(coveragePeriod$) : true
}

export const enableInterestRate = (haveBasicPremiumState, interestRate$) => {
  return haveBasicPremiumState ? interestRate$.isOk : true
}

export const isInvalid = (haveBasicPremiumState, sumAssured$, basicPremium$) => {
  return (
    !enableBasicSumAssured(haveBasicPremiumState, basicPremium$) ||
    !enableBasicPremium(haveBasicPremiumState, sumAssured$) ||
    (!isZero(basicPremium$) && !basicPremium$.isOk) ||
    (!isZero(sumAssured$) && !sumAssured$.isOk)
  )
}
